import React, { useEffect, useState } from "react";
import { BankB1Logo } from "../icons";
import sidebarOptions from "../utils/sidebarOptions";
import { useSelector } from "react-redux";
import { RootState } from "../shared/store";
import { getUserGroupApi } from "../utils/chatHistory";

const Sidebar: React.FC<{}> = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(1);
  const [groups, setGroups] = useState([]);
  const { userId, accessToken } = useSelector(
    (state: RootState) => state.users
  );
  useEffect(() => {
    if (userId) {
      getGroups();
    }
  }, [userId]);
  const getGroups = async () => {
    const response = await getUserGroupApi(userId, accessToken);
    setGroups(
      response.groups
        ?.filter((item: string) => item?.includes("b1Assistant_"))
        ?.map((item: string) => item?.replace("b1Assistant_", ""))
    );
  };
  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.screen.width <= 425 || window.innerWidth <= 425);
    };

    checkScreenSize();

    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  return (
    <div className="sidebar">
      <BankB1Logo />
      <div className="sidebar-items">
        {groups?.length > 0 &&
          groups.map((option, index) => {
            if (index < groups?.length) {
              return (
                <div
                  key={`${index}-option`}
                  className={`sidebar-item ${
                    activeItem === index ? "active" : ""
                  }`}
                  onClick={() => setActiveItem(index)}
                >
                  <div className="icon">
                    {React.cloneElement(sidebarOptions[0].icon, {
                      color: activeItem === index ? "#CC4D23" : "#242634", // change the colors as needed
                    })}
                  </div>
                  <div className="text">{groups[index]}</div>
                </div>
              );
            } else {
              return <></>;
            }
          })}
      </div>
    </div>
  );
};

export default Sidebar;
